import { useTranslation } from '@rhino-project/core/i18n';
import { useBaseOwnerId } from '@rhino-project/core/hooks';

import { ModelCreateForm, ModelCreateModal } from '@rhino-project/ui-heroui';
import { ComponentProps, useMemo } from 'react';
import {
  Alert,
  AlertContent,
  AlertDescription,
  ModalBody
} from '@heroui/react';
import { RhinoPathEntries } from '@rhino-project/core';

interface FirstTeamMessageProps extends ComponentProps<typeof ModelCreateForm> {
  isFirstTeam?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FirstTeamMessage = ({ isFirstTeam, ...props }: FirstTeamMessageProps) => {
  const { t } = useTranslation();

  return (
    <ModalBody>
      <Alert>
        <AlertContent>
          <AlertDescription>
            <p>
              {t(
                'frontend.messages.welcome_to_elite_sports_program_manager_the_tool_of_choice_for'
              )}
            </p>
            <p>{t('frontend.messages.create_your_first_team')}</p>
          </AlertDescription>
        </AlertContent>
      </Alert>
      <ModelCreateForm {...props} />
    </ModalBody>
  );
};

const paths: RhinoPathEntries<'team'> = ['name'];

interface OtsSidebarFormProps extends ComponentProps<typeof ModelCreateModal> {
  isFirstTeam?: boolean;
}

const OtsSidebarForm = (props: OtsSidebarFormProps) => {
  const { isFirstTeam = false } = props;
  const baseOwnerId = useBaseOwnerId();

  const overrides = useMemo(() => {
    if (isFirstTeam) {
      return {
        ModelCreateModalForm: FirstTeamMessage
      };
    }

    return undefined;
  }, [isFirstTeam]);

  return (
    <ModelCreateModal
      {...props}
      overrides={overrides}
      model="team"
      parentId={baseOwnerId}
      paths={paths}
      hasCancel={!isFirstTeam}
    />
  );
};

export default OtsSidebarForm;
